import {Component, Input} from '@angular/core';
import {AppComponent} from "../../app.component";
import {SiteLayoutComponent} from "../../core/layout/site/site-layout.component";
import {CurrentUserViewModel} from "../../core/models/current-user.view-model";
import {TokenDataProviderService} from "../../core/services/token-data-provider.service";
import {MediaObjectPipe} from "../../core/pipes/media-object.pipe";
import {ResponseNotificationService} from "../../core/services/response-notification.service";
import {ModalService} from "../modal/modal.service";
import {TutorialOrchestratorService} from "../../core/onboarding/tutorial-orchestrator.service";
import {TranslateService} from "@ngx-translate/core";
import {INSPECTION_NAVIGATION_ITEMS} from '../navigation/main-navigation.config';

@Component({
  selector: 'app-inline-menu',
  templateUrl: './app.inlinemenu.component.html',
})
export class AppInlineMenuComponent {
  readonly inspectionNavigationItems = INSPECTION_NAVIGATION_ITEMS;

  get currentBackgroundStyles() {
    return {
      'background-image': `url("${MediaObjectPipe.transformToLink(this.user.background, {defaultImageType: 'background'})}")`,
      'background-size': 'cover',
      'background-position': 'center'
    };
  }

  get user(): CurrentUserViewModel {
    return this._user;
  }

  @Input() set user(value: CurrentUserViewModel) {
    this._user = value;
  }

  @Input() key = "inline-menu";

  @Input() section: 'full' | 'shortcuts' | 'profile' = 'full';

  @Input() style: any;

  @Input() styleClass: string;

  private _user: CurrentUserViewModel;

  constructor(
    public appMain: SiteLayoutComponent,
    public app: AppComponent,
    private ts: TokenDataProviderService,
    private modalService: ModalService,
    private rns: ResponseNotificationService,
    private readonly tutorialOrchestrator: TutorialOrchestratorService,
    private readonly translate: TranslateService,
  ) {
  }

  get isTooltipDisabled() {
    return !(this.appMain.isSlim() && !this.appMain.isMobile());
  }

  get tabIndex() {
    // All rendered user shortcuts stay expanded, irrespective of their position.
    return null;
  }

  public logout(event: Event): void {
    this.ts.logout();
  }

  public onClickNavigationElement(): void {
    this.appMain.resetActiveMenus();
  }

  public openBugReport(event: Event): void {
    event.preventDefault();
    this.modalService.showBugReportModal({
      errorCode: this.rns.lastErrorCode,
      errorContext: this.rns.lastErrorContext
    });
  }

  public async startCurrentViewTutorial(event: Event): Promise<void> {
    event.preventDefault();
    this.appMain.resetActiveMenus();

    const started = await this.tutorialOrchestrator.startMatchingCampaignForCurrentRoute(true);
    if (!started) {
      this.rns.emitWarning(this.translate.instant('tutorials.settings.actions.unavailable'));
    }
  }
}
